module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-126.9f3eb7b.woff2";